<template>
  <div class="box mt-5">
    <h1 class="title is-2 has-text-weight-medium has-text-centered">Facultad de Ingeniería</h1>
    <b-tabs :size="size"
            :type="type"
            :expanded=false
            position="is-centered"
    >
      <b-tab-item label="Autoridades" icon="users">
        <h1 class="title is-2 has-text-weight-medium has-text-centered">Autoridades</h1>
        <div class="columns is-centered">
          <div class="column is-one-third" style="display:flex; flex-direction:column;">
            <div class="box" style="flex:1; display:flex; flex-direction:column; text-align:center;">
              <div style="display:flex; justify-content:center;">
                <div style="position:relative; display:inline-flex;">
                  <div style="cursor:pointer;" @click="redirect(autoridades.decano && autoridades.decano.id)">
                    <b-image
                        :src=getPhotoUrl(autoridades.decano)
                        alt="Foto de perfil"
                        style="max-width:200px; height:200px;"
                        :rounded="true"
                    ></b-image>
                  </div>
                  <b-button
                    v-if="canEditAuthorities && autoridades.decano && autoridades.decano.id"
                    style="position:absolute; bottom:4px; right:4px;"
                    size="is-small" type="is-info" rounded
                    icon-left="camera"
                    @click.stop="abrirModalFoto(autoridades.decano)"
                  />
                </div>
              </div>
              <p class="title is-5 mt-3" style="color:#A2A9AD;">{{autoridades.decano ? autoridades.decano.cargo : ""}}</p>
              <h4 class="subtitle is-4" style="color:#EF7D00;">{{autoridades.decano ? autoridades.decano.nombre : ""}}</h4>
              <h5 class="title is-5" style="color:#A2A9AD;">Correo Electrónico</h5>
              <h5 class="subtitle is-5" style="color:#A2A9AD; word-break:break-all;">{{autoridades.decano ? autoridades.decano.correo : ""}}</h5>
              <div v-if="canEditAuthorities" style="margin-top:auto;" class="pt-2">
                <b-button size="is-small" type="is-warning is-light" icon-left="edit" @click.stop="abrirModalEdicion('decano')">Editar</b-button>
              </div>
            </div>
          </div>
        </div>
        <div class="columns">
          <div class="column" style="display:flex; flex-direction:column;">
            <div class="box" style="flex:1; display:flex; flex-direction:column; text-align:center;">
              <div style="display:flex; justify-content:center;">
                <div style="position:relative; display:inline-flex;">
                  <div style="cursor:pointer;" @click="redirect(autoridades.vice_forma && autoridades.vice_forma.id)">
                    <b-image :src=getPhotoUrl(autoridades.vice_forma) alt="Foto de perfil" style="max-width:200px; height:200px;" :rounded="true"></b-image>
                  </div>
                  <b-button
                    v-if="canEditAuthorities && autoridades.vice_forma && autoridades.vice_forma.id"
                    style="position:absolute; bottom:4px; right:4px;"
                    size="is-small" type="is-info" rounded
                    icon-left="camera"
                    @click.stop="abrirModalFoto(autoridades.vice_forma)"
                  />
                </div>
              </div>
              <p class="title is-5 mt-3" style="color:#A2A9AD;">{{autoridades.vice_forma ? autoridades.vice_forma.cargo : ""}}</p>
              <h4 class="subtitle is-4" style="color:#EF7D00;">{{autoridades.vice_forma ? autoridades.vice_forma.nombre : ""}}</h4>
              <h5 class="title is-5" style="color:#A2A9AD;">Correo Electrónico</h5>
              <h5 class="subtitle is-5" style="color:#A2A9AD; word-break:break-all;">{{autoridades.vice_forma ? autoridades.vice_forma.correo : ""}}</h5>
              <div v-if="canEditAuthorities" style="margin-top:auto;" class="pt-2">
                <b-button size="is-small" type="is-warning is-light" icon-left="edit" @click.stop="abrirModalEdicion('vice_forma')">Editar</b-button>
              </div>
            </div>
          </div>
          <div class="column" style="display:flex; flex-direction:column;">
            <div class="box" style="flex:1; display:flex; flex-direction:column; text-align:center;">
              <div style="display:flex; justify-content:center;">
                <div style="position:relative; display:inline-flex;">
                  <div style="cursor:pointer;" @click="redirect(autoridades.vice_id && autoridades.vice_id.id)">
                    <b-image :src=getPhotoUrl(autoridades.vice_id) alt="Foto de perfil" style="max-width:200px; height:200px;" :rounded="true"></b-image>
                  </div>
                  <b-button
                    v-if="canEditAuthorities && autoridades.vice_id && autoridades.vice_id.id"
                    style="position:absolute; bottom:4px; right:4px;"
                    size="is-small" type="is-info" rounded
                    icon-left="camera"
                    @click.stop="abrirModalFoto(autoridades.vice_id)"
                  />
                </div>
              </div>
              <p class="title is-5 mt-3" style="color:#A2A9AD;">{{autoridades.vice_id ? autoridades.vice_id.cargo : ""}}</p>
              <h4 class="subtitle is-4" style="color:#EF7D00;">{{autoridades.vice_id ? autoridades.vice_id.nombre : ""}}</h4>
              <h5 class="title is-5" style="color:#A2A9AD;">Correo Electrónico</h5>
              <h5 class="subtitle is-5" style="color:#A2A9AD; word-break:break-all;">{{autoridades.vice_id ? autoridades.vice_id.correo : ""}}</h5>
              <div v-if="canEditAuthorities" style="margin-top:auto;" class="pt-2">
                <b-button size="is-small" type="is-warning is-light" icon-left="edit" @click.stop="abrirModalEdicion('vice_id')">Editar</b-button>
              </div>
            </div>
          </div>
          <div class="column" style="display:flex; flex-direction:column;">
            <div class="box" style="flex:1; display:flex; flex-direction:column; text-align:center;">
              <div style="display:flex; justify-content:center;">
                <div style="position:relative; display:inline-flex;">
                  <div style="cursor:pointer;" @click="redirect(autoridades.secretario && autoridades.secretario.id)">
                    <b-image :src=getPhotoUrl(autoridades.secretario) alt="Foto de perfil" style="max-width:200px; height:200px;" :rounded="true"></b-image>
                  </div>
                  <b-button
                    v-if="canEditAuthorities && autoridades.secretario && autoridades.secretario.id"
                    style="position:absolute; bottom:4px; right:4px;"
                    size="is-small" type="is-info" rounded
                    icon-left="camera"
                    @click.stop="abrirModalFoto(autoridades.secretario)"
                  />
                </div>
              </div>
              <p class="title is-5 mt-3" style="color:#A2A9AD;">{{autoridades.secretario ? autoridades.secretario.cargo : ""}}</p>
              <h4 class="subtitle is-4" style="color:#EF7D00;">{{autoridades.secretario ? autoridades.secretario.nombre : ""}}</h4>
              <h5 class="title is-5" style="color:#A2A9AD;">Correo Electrónico</h5>
              <h5 class="subtitle is-5" style="color:#A2A9AD; word-break:break-all;">{{autoridades.secretario ? autoridades.secretario.correo : ""}}</h5>
              <div v-if="canEditAuthorities" style="margin-top:auto;" class="pt-2">
                <b-button size="is-small" type="is-warning is-light" icon-left="edit" @click.stop="abrirModalEdicion('secretario')">Editar</b-button>
              </div>
            </div>
          </div>
          <div class="column" style="display:flex; flex-direction:column;">
            <div class="box" style="flex:1; display:flex; flex-direction:column; text-align:center;">
              <div style="display:flex; justify-content:center;">
                <div style="position:relative; display:inline-flex;">
                  <div style="cursor:pointer;" @click="redirect(autoridades.dir_vime && autoridades.dir_vime.id)">
                    <b-image :src=getPhotoUrl(autoridades.dir_vime) alt="Foto de perfil" style="max-width:200px; height:200px;" :rounded="true"></b-image>
                  </div>
                  <b-button
                    v-if="canEditAuthorities && autoridades.dir_vime && autoridades.dir_vime.id"
                    style="position:absolute; bottom:4px; right:4px;"
                    size="is-small" type="is-info" rounded
                    icon-left="camera"
                    @click.stop="abrirModalFoto(autoridades.dir_vime)"
                  />
                </div>
              </div>
              <p class="title is-5 mt-3" style="color:#A2A9AD;">{{autoridades.dir_vime ? autoridades.dir_vime.cargo : ""}}</p>
              <h4 class="subtitle is-4" style="color:#EF7D00;">{{autoridades.dir_vime ? autoridades.dir_vime.nombre : ""}}</h4>
              <h5 class="title is-5" style="color:#A2A9AD;">Correo Electrónico</h5>
              <h5 class="subtitle is-5" style="color:#A2A9AD; word-break:break-all;">{{autoridades.dir_vime ? autoridades.dir_vime.correo : ""}}</h5>
              <div v-if="canEditAuthorities" style="margin-top:auto;" class="pt-2">
                <b-button size="is-small" type="is-warning is-light" icon-left="edit" @click.stop="abrirModalEdicion('dir_vime')">Editar</b-button>
              </div>
            </div>
          </div>
        </div>
        <h1 class="title is-2 has-text-weight-medium has-text-centered">Autoridades Departamentos</h1>
        <div v-for="(object, i) in autoridades_departamentos" :key="i">
          <div v-if="i % 3 === 0" class="columns">
            <div v-for="j in [i, i+1, i+2]" :key="j" class="column" style="display:flex; flex-direction:column;">
              <div v-if="j < autoridades_departamentos.length"
                   class="box"
                   style="flex:1; display:flex; flex-direction:column; text-align:center;">
                <div style="display:flex; justify-content:center;">
                  <div style="position:relative; display:inline-flex;">
                    <div style="cursor:pointer;" @click="redirect(autoridades_departamentos[j].id)">
                      <b-image
                          :src="getPhotoUrl(autoridades_departamentos[j])"
                          alt="Foto de perfil"
                          style="max-width:200px; height:200px;"
                          :rounded="true"
                      ></b-image>
                    </div>
                    <b-button
                      v-if="canEditAuthorities && autoridades_departamentos[j].id"
                      style="position:absolute; bottom:4px; right:4px;"
                      size="is-small" type="is-info" rounded
                      icon-left="camera"
                      @click.stop="abrirModalFoto(autoridades_departamentos[j])"
                    />
                  </div>
                </div>
                <p class="title is-5 mt-3" style="color:#A2A9AD;">{{autoridades_departamentos[j].cargo}}</p>
                <h4 class="subtitle is-4" style="color:#EF7D00;">{{autoridades_departamentos[j].director}}</h4>
                <h5 class="title is-5" style="color:#A2A9AD;">Correo Electrónico</h5>
                <h5 class="subtitle is-5" style="color:#A2A9AD; word-break:break-all;">{{autoridades_departamentos[j].correo}}</h5>
                <div v-if="canEditAuthorities" style="margin-top:auto;" class="pt-2">
                  <b-button size="is-small" type="is-warning is-light" icon-left="edit"
                            @click.stop="abrirModalEdicionDepartamento(autoridades_departamentos[j])">
                    Editar
                  </b-button>
                </div>
              </div>
              <div v-else class="box is-shadowless" style="flex:1; background:transparent; border:none;"></div>
            </div>
          </div>
        </div>
      </b-tab-item>

      <b-tab-item label="Departamentos académicos" icon="school">
        <h1 class="title is-2 has-text-weight-medium has-text-centered">Departamentos académicos</h1>
        <div class="columns is-multiline" :data="departamentos">
          <div class="column is-one-third" v-for="dpto in departamentos" :key="dpto.id">
            <div class="tile notification is-primary box">
              <a @click="goToUnit(dpto.id)"><p class="title is-4">{{dpto.name}}</p></a>
            </div>
          </div>
        </div>
      </b-tab-item>

    </b-tabs>

    <b-modal v-model="editModal.active" has-modal-card trap-focus :destroy-on-hide="true">
      <modal-asignar-autoridad
        v-if="editModal.active"
        :cargo-label="editModal.cargoLabel"
        :persona-actual="editModal.personaActual"
        :function-options="editModal.functionOptions"
        :unit-id="editModal.unitId"
        @close="editModal.active = false"
        @saved="recargarAutoridades"
      />
    </b-modal>

    <b-modal v-model="photoModal.active" has-modal-card trap-focus :destroy-on-hide="true">
      <modal-edit-profile-photo
        v-if="photoModal.active"
        :person="photoModal.person"
        :image="photoModal.image"
        @close="onPhotoModalClose"
      />
    </b-modal>

    <b-loading :is-full-page="true" v-model="isLoading" :can-cancel="false"></b-loading>
  </div>
</template>


<script>
import axios from "axios";
import ModalAsignarAutoridad from "./faculty/modal_asignar_autoridad.vue";
import ModalEditProfilePhoto from "./person/modal_edit_profile_photo.vue";

export default {
  components: { ModalAsignarAutoridad, ModalEditProfilePhoto },
  data(){
    return{
      type: "is-boxed",
      size: "is-small",
      isLoading: false,
      departamentos: [],
      autoridades: [],
      autoridades_departamentos: [],
      canEditAuthorities: false,
      editModal: {
        active:          false,
        cargoLabel:      "",
        personaActual:   null,
        functionOptions: [],
        unitId:          null,
      },
      photoModal: {
        active: false,
        person: null,
        image:  null,
      },
    }
  },
  created(){
    this.isLoading = true;
    return axios.get("/admin/units/"+this.unitId+".json")
        .then(res => {
          this.autoridades               = res.data['autoridades'];
          this.departamentos             = res.data['departamentos'];
          this.autoridades_departamentos = res.data['autoridades_departamentos'];
          this.canEditAuthorities        = res.data['can_edit_authorities'] || false;
          this.isLoading = false;
        })
        .catch(e => {
          this.isLoading = false;
          console.log(e);
        });
  },
  props:['unitId'],
  methods:{
    goToUnit(unit_id){
      this.isLoading = true;
      window.location.href = "/admin/units/"+unit_id;
    },
    redirect(id){
      if(id===undefined || id === null){ return; }
      return window.location.href = '/people/'+id;
    },
    getPhotoUrl(person){
      if (person && person.photo_url){ return person.photo_url; }
      return "/blank_profile_photo.png";
    },
    abrirModalEdicion(key){
      const autoridad = this.autoridades[key];
      if (!autoridad) return;
      this._openModal(autoridad, parseInt(this.unitId));
    },
    abrirModalEdicionDepartamento(autoridad){
      if (!autoridad) return;
      this._openModal(autoridad, autoridad.unit_id);
    },
    _openModal(autoridad, unitId){
      this.editModal.cargoLabel      = autoridad.cargo || "";
      this.editModal.personaActual   = autoridad.nombre ? {
        nombre:             autoridad.nombre,
        person_function_id: autoridad.person_function_id,
        start_date:         autoridad.start_date,
      } : null;
      this.editModal.functionOptions = autoridad.function_options || [];
      this.editModal.unitId          = unitId || null;
      this.editModal.active          = true;
    },
    abrirModalFoto(autoridad){
      if (!autoridad || !autoridad.id) return;
      this.photoModal.person = { id: autoridad.id };
      this.photoModal.image  = autoridad.photo_url || null;
      this.photoModal.active = true;
    },
    onPhotoModalClose(){
      this.photoModal.active = false;
      this.recargarAutoridades();
    },
    recargarAutoridades(){
      this.isLoading = true;
      axios.get("/admin/units/"+this.unitId+".json")
        .then(res => {
          this.autoridades               = res.data['autoridades'];
          this.autoridades_departamentos = res.data['autoridades_departamentos'];
          this.isLoading                 = false;
        })
        .catch(e => {
          this.isLoading = false;
          console.log(e);
        });
    },
  },
  computed:{}
}
</script>
